import { CheckboxOption, SelectOption } from './types'

export const appointmentRequestOptions: CheckboxOption[] = [
	{ id: 'acceptingPatients', label: 'Accepting New Patients' },
	{ id: 'virtualVisit', label: 'Virtual Visit Capability' },
	// { id: 'callbackRequest', label: 'Allow Patients to Send You Callback Requests' },
	{ id: 'onlineScheduling', label: 'Allow Online Patient Scheduling' }
]

export const appointmentTimeRangeOptions: SelectOption[] = [
	{ label: 'Today', value: 'today' },
	{ label: 'Tomorrow', value: 'tomorrow' },
	{ label: 'Next 7 days', value: 'next7days' },
	{ label: 'Next 30 days', value: 'next30days' },
	{ label: 'Past Appointments', value: 'past' },
	{ label: 'Last 7 days', value: 'past7days' },
	{ label: 'Last 30 days', value: 'past30days' },
	{ label: 'All Appointments', value: 'all' }
]
